import React from 'react';
import Button from '../common/Button';

interface DownloadModalProps {
    isOpen: boolean;
    onClose: () => void;
    downloadInfo?: {
        toBeDownloadedCount: number;
        canBeDownloadedCount: number;
        reDownloadCount: number;
        lastDownloadedCustomerUserName?: string;
    };
    onDownload: (type: 'all' | 'downloadable' | 'redownload') => void;
    hasNotDownloadedData?: boolean;
}

const DownloadModal: React.FC<DownloadModalProps> = ({
    isOpen,
    onClose,
    downloadInfo,
    onDownload,
    hasNotDownloadedData
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 items-center z-50">
            <div className="bg-white my-[15%] mx-auto w-4/5 max-w-lg p-5 border-[#888] rounded text-center text-black">
                <div className="modal-content">
                    <div className="flex flex-row justify-between items-center border-b">
                        <h3 className="modal-title">ダウンロード</h3>
                        <button
                            className="close"
                            onClick={onClose}
                        >
                            &times;
                        </button>
                    </div>
                    <div className="text-left p-4">
                        {downloadInfo && (
                            <>
                                {hasNotDownloadedData ? (
                                    <div className="mb-4">
                                        <div className="flex justify-between items-center mb-2">
                                            <span>未ダウンロード全て</span>
                                            <Button
                                                label="ダウンロード"
                                                onClick={() => onDownload('all')}
                                                addedClass="text-sm px-3 py-1"
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="mb-4">
                                        <div className="flex justify-between items-center mb-2">
                                            <span>未ダウンロードの認証情報はありません</span>
                                        </div>
                                    </div>
                                )}

                                <div className="mb-4">
                                    <div className="flex justify-between items-center mb-2">
                                        <span>ダウンロード済みのもの全て</span>
                                        <Button
                                            label="ダウンロード"
                                            onClick={() => onDownload('redownload')}
                                            addedClass="text-sm px-3 py-1"
                                        />
                                    </div>
                                </div>

                                {downloadInfo.lastDownloadedCustomerUserName && (
                                    <div className="mt-4 pt-4 border-t">
                                        <p className="text-sm text-gray-600">
                                            最終ダウンロードユーザー: {downloadInfo.lastDownloadedCustomerUserName}
                                        </p>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className='flex flex-row justify-end'>
                        <div className='m-[10px]'>
                            <Button
                                label={'閉じる'}
                                onClick={onClose}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DownloadModal;
